import { themeGet } from '@styled-system/theme-get';
import { Box, getPaletteColor } from 'pcln-design-system';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';
import monthNameBuilder from '../utils/monthNameBuilder/monthNameBuilder';
const MonthNameBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "MonthName__MonthNameBox",
  componentId: "sc-1xhbvbo-0"
})(["&&&{font-size:", "px;font-weight:", ";color:", ";text-transform:capitalize;", "{", "}}"], props => props.theme.fontSizes[props.use2024DesignSeti ? 3 : 2], props => props.theme.bold, props => getPaletteColor(props.use2024DesignSeti ? 'primary.dark' : 'text.light')(props), themeGet('mediaQueries.md'), props => !props.use2024DesignSeti && `
        color: ${getPaletteColor('text.dark')(props)} !important;
        background: ${getPaletteColor('background.lightest')(props)} !important;
      `);
function MonthName({
  displayYear,
  locale,
  monthIndex,
  use2024DesignSeti,
  year,
  ...props
}) {
  const memoizedMonthNames = useMemo(() => monthNameBuilder({
    format: 'wide',
    locale
  })[monthIndex], [locale]);
  return React.createElement(MonthNameBox, {
    ...props,
    borderRadius: 'lg',
    color: use2024DesignSeti ? undefined : 'background.light',
    textAlign: use2024DesignSeti ? ['left', null, 'center'] : 'center',
    use2024DesignSeti: use2024DesignSeti,
    py: 2
  }, memoizedMonthNames, displayYear && ` ${year}`);
}
export default memo(MonthName);